import React from "react";
import { cn } from "@/lib/utils";
import { renderEditableCell } from "../../utils";
import type { BaseEntity } from "../../types";
import type { SpecializedCellProps } from "./tableCellSpecializedFields.types";

/**
 * DueDateCell renders the due_date field with special formatting
 */
export function DueDateCell<TData extends BaseEntity>({
  fieldValue,
  fieldConfig,
  item,
  state,
  callbacks,
  data,
  inlineEditHandler,
}: SpecializedCellProps<TData>) {
  return (
    <div className="min-w-0">
      {renderEditableCell<TData>(
        fieldValue,
        fieldConfig,
        item.id,
        "due_date",
        state.editingCell,
        state.editValue,
        callbacks.handleCellEditCallback,
        callbacks.handleCellSaveCallback,
        callbacks.handleCellCancelCallback,
        state.setEditValue,
        data,
        inlineEditHandler
      )}
    </div>
  );
}

/**
 * DefaultCell renders generic/default fields
 */
export function DefaultCell<TData extends BaseEntity>({
  fieldId,
  fieldValue,
  fieldConfig,
  item,
  isEditing,
  isTextareaField,
  state,
  callbacks,
  data,
  inlineEditHandler,
}: SpecializedCellProps<TData>) {
  const editable = renderEditableCell<TData>(
    fieldValue,
    fieldConfig,
    item.id,
    fieldId,
    state.editingCell,
    state.editValue,
    callbacks.handleCellEditCallback,
    callbacks.handleCellSaveCallback,
    callbacks.handleCellCancelCallback,
    state.setEditValue,
    data,
    inlineEditHandler
  );

  return (
    <div
      className={cn(
        "min-w-0 h-full",
        isTextareaField && !isEditing && "flex items-center overflow-hidden"
      )}
    >
      {isTextareaField && !isEditing ? (
        <div className="w-full line-clamp-3 break-words text-sm">{editable}</div>
      ) : (
        editable
      )}
    </div>
  );
}
